import React from 'react';
import { STIcon } from 'components/Brand/Icons/STIcon';
import { WebsiteImage } from 'components/TitleDescription';
import CardsBodyWrapper from '../CardsBodyWrapper';
import { IconContainer, TitleContainer, DescriptionContainer } from './styles';

const IconCard = props => {
  const { iconType, iconImage, title, description, align } = props;
  return (
    <div
      role="listitem"
      data-testid="icon-card-body-wrapper"
      className="card--body-wrapper icon-card--body-wrapper"
    >
      {(iconImage || iconType) && (
        <IconContainer
          data-testid="icon-container"
          className={`icon-card--icon-container align-${align}`}
        >
          {iconImage ? (
            <WebsiteImage className="icon-card--image" src={iconImage.image} alt={title} />
          ) : (
            <STIcon type={iconType} size="large" />
          )}
        </IconContainer>
      )}
      <div data-testid="icon-card-text-container" className="icon-card--text-container">
        {title && (
          <TitleContainer className={'simple-responsive'}>
            <p>{title}</p>
          </TitleContainer>
        )}
        {description && (
          <DescriptionContainer>
            <p>{description}</p>
          </DescriptionContainer>
        )}
      </div>
    </div>
  );
};

export default CardsBodyWrapper(IconCard);
